import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import appConfig from '@/appConfig';
import resolveNightCardProgramInfoUrl from '@/utils/resolveNightCardProgramInfoUrl';
import { SNightCardManagementPanel } from '@slg/web-customer-shared';
import { useStore, useI18n, useGlobalErrorDialog } from '@/composables';


const __default__ = {
  name: 'SettingsNightCard',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const { i18n } = useI18n();
const { setGlobalError } = useGlobalErrorDialog();

const getUserProfile = computed(() => store.getters['auth/getUserProfile']);
const nightCardProgramInfoUrl = computed(() => resolveNightCardProgramInfoUrl(
  appConfig.nightCardProgramInfoUrl,
  i18n.locale,
  appConfig,
));

function setGlobalLoading(loadingState: boolean) {
  store.commit('common/setGlobalLoading', loadingState);
}

async function populateUserProfileInfo() {
  try {
    await store.dispatch('auth/populateUserProfileInfo');
  } catch (e) {
    await setGlobalError(e as any);
  }
}

return { __sfc: true,store, i18n, setGlobalError, getUserProfile, nightCardProgramInfoUrl, setGlobalLoading, populateUserProfileInfo, SNightCardManagementPanel }
}

})